import Select from 'react-select'

import './FilterActivos.css';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import nivel1Context from '../../context/nivel1Context/nivel1Context';
import { ACTIVOSTATES, CRITICIDAD } from '../../utils/states';
import { COLOR_FONDO, COLOR_TEXTO, PRINCIPAL, NAVBARS } from '../../constants/colors';
import { unidadesMedidasOpciones } from '../../utils/estructuras';
import DictionaryText from '../dictionaryText/DictionaryText';
import nivel2Context from '../../context/nivel2Context/nivel2Context';
import nivel3Context from '../../context/nivel3Context/nivel3Context';
import nivel4Context from '../../context/nivel4Context/nivel4Context';
import nivel5Context from '../../context/nivel5Context/nivel5Context';
import authContext from '../../context/authentication/authContex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export const FilterActivos = ({setShowFilter, filtros, setFiltros}) => {

    const {nivel1Lista} = useContext(nivel1Context);
    const {nivel2List} = useContext(nivel2Context);
    const {nivel3List} = useContext(nivel3Context);
    const {nivel4List} = useContext(nivel4Context);
    const {nivel5List} = useContext(nivel5Context);
    const {getValorActualFromDictionary} = useContext(authContext);

    const [nivel1sSelected, setNivel1sSelected] = useState(filtros.areas ? filtros.areas : []);
    const [nivel2sSelected, setNivel2sSelected] = useState(filtros.nivel2s ? filtros.nivel2s : []);
    const [nivel3sSelected, setNivel3sSelected] = useState(filtros.nivel3s ? filtros.nivel3s : []);
    const [nivel4sSelected, setNivel4sSelected] = useState(filtros.nivel4s ? filtros.nivel4s : []);
    const [nivel5sSelected, setNivel5sSelected] = useState(filtros.nivel5s ? filtros.nivel5s : []);
    const [state, setState] = useState(filtros.state ? filtros.state : []);
    const [criticidad, setCriticidad] = useState(filtros.criticidad ? filtros.criticidad : []);
    const [uniMeds, setUniMeds] = useState(filtros.uniMeds ? filtros.uniMeds : []);

    console.log("uniMeds");
    console.log(uniMeds);
    

    const nivel1Options = useMemo(()=>{
        if(nivel1Lista && nivel1Lista.length > 0){
            return nivel1Lista.map((a) => ({label:a.descrp, value:a._id}));
        }else return [];
    },[nivel1Lista])

    const nivel2Options = useMemo(()=>{
        if(nivel2List && nivel2List.length > 0){
            return nivel2List.map(lv2 => {
                if(nivel1sSelected.length > 0 ){
                    if(nivel1sSelected.some(lv1 => lv1.value == lv2.nivel2Nivel1ID)) return {label:lv2.descrp, value: lv2._id}
                } else return {label:lv2.descrp, value: lv2._id};
            }).filter(lv2 => lv2);
        }else return []
    }, [nivel2List, nivel1sSelected])

    const nivel3Options = useMemo(()=>{
        if(nivel3List && nivel3List.length > 0){
            return nivel3List.map(lv3 => {
                if(nivel2sSelected.length > 0){
                    if(nivel2sSelected.some(lv2 => lv2.value == lv3.nivel3Nivel2ID)) return {label:lv3.descrp, value:lv3._id}
                }else return {label:lv3.descrp, value:lv3._id}
            }).filter(lv3 => lv3)
        }else return [];
    },[nivel3List, nivel2sSelected])
    
    const nivel4Options = useMemo(()=>{
        if(nivel4List && nivel4List.length > 0){
            return nivel4List.map(lv4 => {
                if(nivel3sSelected.length > 0){
                    if(nivel3sSelected.some(lv3 => lv3.value == lv3.nivel4Nivel3ID)) return {label:lv4.descrp, value:lv4._id}
                }else return {label:lv4.descrp, value:lv4._id}
            }).filter(lv4 => lv4)
        }else return [];
    },[nivel4List, nivel3sSelected])
    
    const nivel5Options = useMemo(()=>{
        if(nivel5List && nivel5List.length > 0){
            return nivel5List.map(lv5 => {
                if(nivel4sSelected.length > 0){
                    if(nivel4sSelected.some(lv4 => lv4.value == lv5.nivel5Nivel4ID)) return {label:lv5.descrp, value:lv5._id}
                }else return {label:lv5.descrp, value:lv5._id}
            }).filter(lv3 => lv3)
        }else return [];
    },[nivel5List, nivel4sSelected])

    const handleClose = () => {
        setShowFilter(false);
    }

    const handleSetFiltros = () => {
        setFiltros({...filtros, areas: nivel1sSelected, nivel2s: nivel2sSelected, nivel3s: nivel3sSelected, nivel4s: nivel4sSelected, nivel5s: nivel5sSelected, state: state, criticidad, uniMeds});
        handleClose();
    }

    const handleSetState = (stateSelected, action = '') => {
        if(action != ''){
            if(action == 'ALL') setState(ACTIVOSTATES.slice());
            else setState([]);
        }else{
            if(state.includes(stateSelected)) setState((prevState) => {
                return [...prevState.filter(sT => !(sT == stateSelected)).slice()]
            })
            else setState((prevState) => {
                return [...prevState.slice(), stateSelected];
            })
        }
    }
    
    const handleSetCriticidad = (criticidadSelected, action = '') => {
        if(action != ''){
            if(action == 'ALL') setCriticidad(CRITICIDAD.slice());
            else setCriticidad([]);
        }else{
            if(criticidad.includes(criticidadSelected)) setCriticidad((prevState) => {
                return [...prevState.filter(c => !(c == criticidadSelected)).slice()]
            })
            else setCriticidad((prevState) => {
                return [...prevState.slice(), criticidadSelected];
            })
        }
    }
    
    const handleSetUniMeds = (uniMedSelected, action = '') => {
        if(action != ''){
            if(action == 'ALL') setUniMeds(unidadesMedidasOpciones.map(a => a.value).slice());
            else setUniMeds([]);
        }else{
            if(uniMeds.includes(uniMedSelected)) setUniMeds((prevState) => {
                return [...prevState.filter(c => !(c == uniMedSelected)).slice()]
            })
            else setUniMeds((prevState) => {
                return [...prevState.slice(), uniMedSelected];
            })
        }
    }

    const handleChangeNivel1sSelected = (selectedOption) => {
        if(nivel2sSelected.length > 0) setNivel2sSelected([]);
        if(nivel3sSelected.length > 0) setNivel3sSelected([]);
        if(nivel4sSelected.length > 0) setNivel4sSelected([]);
        if(nivel5sSelected.length > 0) setNivel5sSelected([]);
        setNivel1sSelected(selectedOption);
    }
    const handleChangeNivel2sSelected = (selectedOption) => {
        if(nivel3sSelected.length > 0) setNivel3sSelected([]);
        if(nivel4sSelected.length > 0) setNivel4sSelected([]);
        if(nivel5sSelected.length > 0) setNivel5sSelected([]);
        setNivel2sSelected(selectedOption);
    }
    const handleChangeNivel3sSelected = (selectedOption) => {
        if(nivel4sSelected.length > 0) setNivel4sSelected([]);
        if(nivel5sSelected.length > 0) setNivel5sSelected([]);
        setNivel3sSelected(selectedOption);
    }
    const handleChangeNivel4sSelected = (selectedOption) => {
        if(nivel5sSelected.length > 0) setNivel5sSelected([]);
        setNivel4sSelected(selectedOption);
    }
    const handleChangeNivel5sSelected = (selectedOption) => {
        setNivel5sSelected(selectedOption);
    }

    return <div className="filterActivosModalContainer">
        <div className="filterActivosDiv">
            <div className="label-filter-icon-r">
                <div className="filter-title-r" style={{backgroundColor: PRINCIPAL, color: NAVBARS}}>Filtros</div>
                <div className="filter-icon-r">
                    <FontAwesomeIcon icon={faXmark} onClick={handleClose}/>
                </div>
            </div>
            <div className='selectContainer'>
                <label>Seleccione <DictionaryText text={"Nivel 1"}/></label>
                <Select
                    styles={{
                        container: (base) => ({
                            ...base,
                            height:'fit-content'
                        }),
                        multiValueLabel: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }), 
                        multiValueRemove: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }),
                    }}
                    isMulti
                    placeholder={`Seleccione ${getValorActualFromDictionary("Nivel 1")}`}
                    options={nivel1Options}
                    value={nivel1sSelected}
                    onChange={(selectedOption) => handleChangeNivel1sSelected(selectedOption)}                    
                />
            </div>
            <div className='selectContainer'>
                <label>Seleccione <DictionaryText text={"Nivel 2"}/></label>
                <Select
                    styles={{
                        container: (base) => ({
                            ...base,
                            height:'fit-content'
                        }),
                        multiValueLabel: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }), 
                        multiValueRemove: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }),
                    }}
                    isMulti
                    placeholder={`Seleccione ${getValorActualFromDictionary("Nivel 2")}`}
                    options={nivel2Options}
                    value={nivel2sSelected}
                    onChange={(selectedOption) => handleChangeNivel2sSelected(selectedOption)}                    
                />
            </div>
            <div className='selectContainer'>
                <label>Seleccione <DictionaryText text={"Nivel 3"}/></label>
                <Select
                    styles={{
                        container: (base) => ({
                            ...base,
                            height:'fit-content'
                        }),
                        multiValueLabel: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }), 
                        multiValueRemove: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }),
                    }}
                    isMulti
                    placeholder={`Seleccione ${getValorActualFromDictionary("Nivel 3")}`}
                    options={nivel3Options}
                    value={nivel3sSelected}
                    onChange={(selectedOption) => handleChangeNivel3sSelected(selectedOption)}                    
                />
            </div>
            <div className='selectContainer'>
                <label>Seleccione <DictionaryText text={"Nivel 4"}/></label>
                <Select
                    styles={{
                        container: (base) => ({
                            ...base,
                            height:'fit-content'
                        }),
                        multiValueLabel: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }), 
                        multiValueRemove: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }),
                    }}
                    isMulti
                    placeholder={`Seleccione ${getValorActualFromDictionary("Nivel 4")}`}
                    options={nivel4Options}
                    value={nivel4sSelected}
                    onChange={(selectedOption) => handleChangeNivel4sSelected(selectedOption)}                    
                />
            </div>
            <div className='selectContainer'>
                <label>Seleccione <DictionaryText text={"Nivel 5"}/></label>
                <Select
                    styles={{
                        container: (base) => ({
                            ...base,
                            height:'fit-content'
                        }),
                        multiValueLabel: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }), 
                        multiValueRemove: (base) => ({
                            ...base,
                            backgroundColor: "#00D4E2",
                            color: 'white',
                            borderRadius: "none",
                            fontSize: "1rem"
                        }),
                    }}
                    isMulti
                    placeholder={`Seleccione ${getValorActualFromDictionary("Nivel 5")}`}
                    options={nivel5Options}
                    value={nivel5sSelected}
                    onChange={(selectedOption) => handleChangeNivel5sSelected(selectedOption)}                    
                />
            </div>
            
            <div className='btnsOptionsContainer'>
                <div className='headerOptionsDiv'>
                    <label>Filtre por Estado</label>
                    <button className='btnDinamicSelect' onClick={()=>handleSetState('', ACTIVOSTATES.length == state.length ? 'NONE' : 'ALL')}>
                        {ACTIVOSTATES.length == state.length ? 'DESELECCIONAR TODOS' : 'SELECCIONAR TODOS'}
                    </button>
                </div>
                <div className='btnsOptionsDiv'>
                    {
                        ACTIVOSTATES.map(aS => <div style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}} className="container-states-f">
                            <input type="checkbox" name={`state-${aS}`} value={aS} checked={ state.includes(aS) ? true : false } onChange={bool => handleSetState(aS)}/>
                            <label className="filter-priority-item-label">{aS}</label>
                        </div>)
                    }
                </div>
            </div>
            
            <div className='btnsOptionsContainer'>
                <div className='headerOptionsDiv'>
                    <label>Filtre por Criticidad del Activo</label>
                    <button className='btnDinamicSelect' onClick={()=>handleSetCriticidad('', CRITICIDAD.length == criticidad.length ? 'NONE' : 'ALL')}>
                        {CRITICIDAD.length == criticidad.length ? 'DESELECCIONAR TODOS' : 'SELECCIONAR TODOS'}
                    </button>
                </div>
                <div className='btnsOptionsDiv'>
                    {
                        CRITICIDAD.map(aS => <div style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}} className="container-states-f">
                            <input type="checkbox" name={`state-${aS}`} value={aS} checked={ criticidad.includes(aS) ? true : false } onChange={bool => handleSetCriticidad(aS)}/>
                            <label className="filter-priority-item-label">{aS}</label>
                        </div>)
                    }
                </div>
            </div>
            
            <div className='btnsOptionsContainer'>
                <div className='headerOptionsDiv'>
                    <label>Filtre por Unidad de Medida por Defecto</label>
                    <button className='btnDinamicSelect' onClick={()=>handleSetUniMeds('', unidadesMedidasOpciones.length == uniMeds.length ? 'NONE' : 'ALL')}>
                        {unidadesMedidasOpciones.length == uniMeds.length ? 'DESELECCIONAR TODOS' : 'SELECCIONAR TODOS'}
                    </button>
                </div>
                <div className='btnsOptionsDiv'>
                    {
                        unidadesMedidasOpciones.map(aS => <div style={{backgroundColor: COLOR_FONDO, color: COLOR_TEXTO}} className="container-states-f">
                            <input type="checkbox" name={`state-${aS.value}`} value={aS.value} checked={ uniMeds.includes(aS.value) ? true : false } onChange={bool => handleSetUniMeds(aS.value)}/>
                            <label className="filter-priority-item-label">{aS.label}</label>
                        </div>)
                    }
                </div>
            </div>
            

            
            <button className='applyFiltersBtn' onClick={handleSetFiltros}>Aplicar Filtros</button>
        </div>
    </div>

}